import {ReactElement} from 'react';
import {Toolbar, AppBar} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import logo from 'images/logo-bella-aurora.svg';
import PublicUser from 'public/interfaces/PublicUser';
import {TIP_LIBRARY} from 'public/routing/paths';
import Menu from 'shared/components/layout/LoggedInLayout/Header/components/Menu';
import {USER_HOME} from 'shared/routing/paths';
import AnonymousMenu from './components/AnonymousMenu';

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    width: theme.breakpoints.values.lg,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  appBar: {
    backgroundColor: theme.palette.secondary.light
  },
  grow: {
    flexGrow: 1
  },
  logo: {
    width: 150
  }
}));

type Props = {
  publicUser: PublicUser | null;
};

export default function HeaderView({publicUser}: Props): ReactElement {
  const classes = useStyles();
  const {t} = useTranslation(['public/legal']);

  let menu = null;
  if (publicUser) {
    menu = (
      <Menu
        fullname={publicUser.fullname}
        isDoctor={publicUser.isDoctor}
        doctorIsAdmin={publicUser.isAdmin}
      />
    );
  } else {
    menu = <AnonymousMenu t={t} />;
  }

  return (
    <AppBar position="relative" elevation={0} className={classes.appBar} color="default">
      <Toolbar className={classes.toolbar}>
        <Link to={publicUser ? USER_HOME : TIP_LIBRARY} className={classes.logo}>
          <img src={logo} alt="Bella Aurora" />
        </Link>
        <div className={classes.grow} />
        {menu}
      </Toolbar>
    </AppBar>
  );
}
